import React, { Component } from 'react'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer'
import './css/index.css'
import Logo from '../../assets/image/onegml.png'
import gallery1 from '../../assets/image/gallery1.jpg'
import {data_booklist} from '../../dummy/data'
import HeadPage from '../../components/header'
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
export default class index extends Component {
    state={
        photoIndex: 0,
        isOpen: false,
    }
    lightBoxToggle=(i)=>{
        this.setState({photoIndex:i,isOpen:!this.state.isOpen})
    }
    render() {
        const data=data_booklist
        const {photoIndex,isOpen}=this.state
        return (
            <div>
                <Navbar/>
                <br/><br/><br/><br/><br/>
                <section className='booklist-page'>
           
                    <HeadPage title='Book list' subtitle='GML’s Published Books' is_filter={false}/>
                    <hr/>
                    <br/><br/><br/>
                    <div className='booklist-desktop'>
                    {data_booklist.map((data,i)=>(
                    <div key={i}>
                    <div className='booklist-card'>
                        <div className='booklist-card-img'>
                        <img src={data.img}/>
                       </div>
                       <div className='booklist-card-content'>
                            <h2>{data.title}</h2>
                           <br/>
                           <div dangerouslySetInnerHTML={{ __html: data.description }}>
                             
                            </div>
                       </div>
                    </div>
                    <br/><br/><br/>
                    </div>
                    ))}
                    </div>
                    <div className='booklist-mobile'>
                        {data_booklist.map((data,i)=>(
                            <div key={i} onClick={()=>this.lightBoxToggle(i)}>
                                <img src={data.img}/>
                            </div>
                        ))}
                    </div>
                    {isOpen && (
                    <Lightbox
                        mainSrc={data[photoIndex].img}
                        imageCaption={<div className='mobile-capt' style={{color:'white'}} dangerouslySetInnerHTML={{ __html: data[photoIndex].description }}></div>}
                        onCloseRequest={() => this.setState({ isOpen: false })}
                        onMovePrevRequest={() =>
                        this.setState({
                            photoIndex: (photoIndex + data.length - 1) % data.length,
                        })
                        }
                        onMoveNextRequest={() =>
                        this.setState({
                            photoIndex: (photoIndex + 1) % data.length,
                        })
                        }
                    />
                )}
                </section>
               <br/><br/>
                <Footer/>
            </div>
        )
    }
}
